var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 37.125a7.125 7.125 0 1 0 0-14.25 7.125 7.125 0 0 0 0 14.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 37.125a7.125 7.125 0 1 0 0-14.25 7.125 7.125 0 0 0 0 14.25",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 8.6C18.175 8.6 5 20.15 5 30c0 9.4 13.175 21.4 25 21.4 12.5 0 25-11.475 25-21.4 0-9.55-13.175-21.4-25-21.4m0 32.275a10.875 10.875 0 1 1 0-21.75 10.875 10.875 0 0 1 0 21.75",
    opacity: 0.3
  })));
};
export default SvgEye;